import { validateFieldStore } from 'old-store/utils';

export const processBillingAddress = (billingAddress: Record<string, any>) => {
  const updatedBillingAddress = { ...billingAddress };

  Object.keys(updatedBillingAddress).forEach((field) => {
    const error = validateFieldStore(field, updatedBillingAddress[field], updatedBillingAddress);

    updatedBillingAddress[field] = {
      ...updatedBillingAddress[field],
      value: updatedBillingAddress[field]?.value?.trim()
    };

    if (error) {
      updatedBillingAddress[error.name] = {
        ...updatedBillingAddress[error.name],
        error: error.errorText
      };
    } else {
      updatedBillingAddress[field] = {
        ...updatedBillingAddress[field],
        error: ''
      };
    }
  });

  return updatedBillingAddress;
};
